module.exports = __webpack_public_path__ + "img/product-1-thumb-3.5c67142e.jpg";